import {getField, updateField} from 'vuex-map-fields';
import {loadUnit, updateUnit} from '@/modules/ProjectModule/modules/UnitModule/api/unit.api';
import * as floorPlan from './parts/floor-plan.module-part';
import * as accessory from './parts/accessory.module-part';
import * as file from './parts/file.module-part';
import * as image from './parts/image.module-part';
import * as orientation from './parts/orientation.module-part';

function initialState() {
    return {
        unitId:         null,
        designation:    null,
        data:           null,
        accessoryIds:   [],
        orientationIds: [],

        statusId:      null,
        buildingId:    null,
        dispositionId: null,
        typeId:        null,
        phaseId:       null,
        floorPlanId:   null,
        cardFileId:    null,
        fileIds:       [],
        imageIds:      [],

        controls: {
            processing: false,
        },

        floorPlans: [],
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters:    {
        getField,
        unitId:        (state) => state.unitId,
        unitData:      (state) => state.data,
        designation:   (state) => state.designation,
        statusId:      (state) => state.statusId,
        dispositionId: (state) => state.dispositionId,
        buildingId:    (state) => state.buildingId,
        floorPlanId:   (state) => state.floorPlanId,
        cardFileId:    (state) => state.cardFileId,
        typeId:        (state) => state.typeId,
        phaseId:       (state) => state.phaseId,

        processingStatus: (state) => state.controls.processing,

        ...floorPlan.getters,
        ...accessory.getters,
        ...image.getters,
        ...orientation.getters,
        ...file.getters
    },
    actions:    {
        setUnitId:      ({ commit }, unitId) => commit('SET_UNIT_ID', unitId),
        async loadUnit({ getters, commit }) {
            return loadUnit(getters.unitId).then((data) => commit('SET_UNIT', data));
        },
        async updateUnit({ getters, commit }, data) {
            let { id } = data;
            if (!id) {
                id = getters.unitId;
            }
            return updateUnit({ ...data, id }).then((data) => commit('SET_UNIT', data));
        },
        async init({ dispatch }, unitId) {
            await dispatch('reset');
            dispatch('setUnitId', unitId);
            dispatch('setProcessingStatus', true)
            return Promise.all([
                dispatch('loadUnit'),
            ]).finally(() => dispatch('setProcessingStatus', false))
        },
        setDesignation: ({ commit }, designation) => commit('SET_DESIGNATION', designation),

        ...accessory.actions,
        ...floorPlan.actions,
        ...image.actions,
        ...orientation.actions,
        ...file.actions,

        setProcessingStatus: ({ commit }, status) => commit('SET_PROCESSING', status),

        async reset({ commit }) {
            return commit('RESET');
        },
    },
    mutations:  {
        updateField,
        SET_UNIT_ID: (state, unitId) => state.unitId = unitId,
        SET_UNIT:    (state, data) => {
            const {
                designation, status, accessories, type, disposition,
                files, images, phase, orientations, building, floorPlan, cardFile
            } = data;
            state.designation = designation;
            state.statusId = status ? status.id : null;
            state.typeId = type ? type.id : null;
            state.dispositionId = disposition ? disposition.id : null;
            state.phaseId = phase ? phase.id : null;
            state.buildingId = building ? building.id : null;
            state.floorPlanId = floorPlan ? floorPlan.id : null;
            state.cardFileId = cardFile ? cardFile.id : null;
            state.accessoryIds = accessories.map(({ id }) => id);
            state.fileIds = files.map(({ id }) => id);
            state.imageIds = images.map(({ id }) => id);
            state.orientationIds = orientations.map(({ id }) => id);
            state.data = data;
        },

        ...accessory.mutations,
        ...floorPlan.mutations,
        ...image.mutations,
        ...orientation.mutations,
        ...file.mutations,

        SET_DESIGNATION: (state, designation) => state.designation = designation,

        SET_PROCESSING: (state, status) => state.controls.processing = status,

        async RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => state[key] = s[key]);
        }
    }
}
